import { useQuery } from '@tanstack/react-query'
import { AxiosError, HttpStatusCode } from 'axios'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'
import { PayMethods } from '@/components/pages/bill/ui/BillsPayDrawer/BillsPayDrawer.types'

import { FinanceService } from '../lib/finance.service'
import { BalanceAlias, PaySystem } from '../lib/finance.types'

export const FINANCE_PAYMENT_DETAIL = 'payment-detail'

type Props = {
  personalAccountId?: string
  alias?: BalanceAlias
  invoiceId?: string
  enabled: boolean
}

export const usePaymentDetail = ({
  personalAccountId,
  alias,
  enabled,
  invoiceId
}: Props) => {
  const { selectedProjectId } = useSelectedProjectStore()

  const { data, isLoading, error } = useQuery({
    queryKey: [
      FINANCE_PAYMENT_DETAIL,
      selectedProjectId,
      personalAccountId,
      alias,
      invoiceId
    ],
    queryFn: () =>
      FinanceService.getPaymentDetail({
        projectId: selectedProjectId,
        personalAccountId,
        balanceTypeAlias: alias,
        invoiceId
      }),
    enabled,
    staleTime: 0
  })

  const options = isLoading
    ? []
    : [
        ...(data?.cards || []),
        { id: PayMethods.Acquiring, paySystem: PaySystem.Acquiring },
        ...(data?.invoices?.[0]?.qrContent
          ? [{ id: PayMethods.Qr, paySystem: PaySystem.Qr }]
          : [])
      ]

  return {
    data: { ...data, cards: options },
    isLoading,
    errorStatus:
      ((error as AxiosError)?.response?.status as unknown as HttpStatusCode) ||
      ''
  }
}
